import OnboardingProgressCircle from "common/components/OnboardingProgressCircle";
import useOnboardingProgress from "common/hooks/useOnboardingProgress";

export default function OnboardingProgress() {
  const { completedStepsCount, isLoadingProgress } = useOnboardingProgress();

  return (
    <OnboardingProgressCircle
      isLoading={isLoadingProgress}
      value={completedStepsCount}
      size="sm"
    />
  );
}
